module.exports = __webpack_public_path__ + "img/1-(4).ec2c27ce.jpg";